export const MODELS_COMPARISON = {
  HOME: 'models_comparison',
  CATEGORY: 'models_comparison_category',
  COMPARISON_RESULTS: 'models_comparison_comparison_results',
}
